// src/authToken.js
export function getAuthToken() {
    return (
        localStorage.getItem('jwt') ||
        localStorage.getItem('token') || // fallback dla starego zapisu
        sessionStorage.getItem('jwt') ||
        ''
    );
}
